// extracted by mini-css-extract-plugin
module.exports = {"block":"block--yAC6O","divider":"divider--LmizE","button":"button--zDHZX"};